import dayjs, { Dayjs } from 'dayjs';
import { LegLocation } from '../Api/Trinium/Endpoints/Leg';
import { Customer } from '../Api/Trinium/Endpoints/Customer/types';
import { AssignedDriver } from '../Forms/Driver/types';
import { JobCategory } from '../Api/Trinium/Endpoints/JobCategories/types';
import { Service } from '../Api/Trinium/Endpoints/Service/types';
import { LocationListItem } from '../Api/Trinium/Endpoints/Location/types';

export interface FormValues {
  terminalNumber: string;
  reportName: string;
  accept: string;
  catId?: string;
  jobCategories?: JobCategory[];
  cntrProviderId?: string;
  assignedDriver?: AssignedDriver;
  customers?: Customer[];
  customer?: Customer;
  reportStyle?: string;
  reportType?: string;
  pickupLocation?: LegLocation;
  deliverLocation?: LegLocation;
  consignees?: LocationListItem[];
  dateFilter?: string;
  allCharges?: boolean;
  sortBy?: string;
  reportDateRange?: [Dayjs, Dayjs];
  deliveryDateRange?: [Dayjs | null, Dayjs | null];
  dateType?: string;
  inclFsc: boolean;
  totalsOnly: boolean;
  driverPay: string;
  services?: Service[];
}

export interface ReportItem {
  code: string;
  name: string;
}

export function SetReportParams(values: FormValues): URLSearchParams {
  const params = new URLSearchParams();

  // common report params
  if (values.reportName !== 'OrdersWithoutCharges' && values.reportName !== 'NotFullyDelivered') {
    params.append('fromDate', values.reportDateRange?.[0] ? dayjs(values.reportDateRange[0]).format('MM/DD/YYYY') : '');
    params.append('toDate', values.reportDateRange?.[1] ? dayjs(values.reportDateRange[1]).format('MM/DD/YYYY') : '');
  }

  // set report specific params
  switch (values.reportName) {
    case 'CSREfficiency':
      params.append('catId', values.catId ?? '');
      params.append('cntrProviderId', values.cntrProviderId ?? ''); // not currently used but required by report
      params.append('custId', values.customer?.id ?? '');
      params.append('delvId', values.deliverLocation?.id ?? '');
      params.append('puId', values.pickupLocation?.id ?? '');
      params.append('reportStyle', values.reportStyle === 'User Summary' ? '1' : '5');
      break;
    case 'NonInvoicedChargesAging':
      params.append('custId', values.customers?.map((customer) => customer.id).join(',') ?? '');
      params.append('dateFilter', values.dateFilter === 'Delivery Date' ? '1' : '2');
      params.append('inclCharges', values.allCharges ? 'true' : 'false');
      break;
    case 'OrdersWithoutCharges':
      params.append('delvFromDate', values.reportDateRange?.[0] ? dayjs(values.reportDateRange[0]).format('MM/DD/YYYY') : '');
      params.append('delvToDate', values.reportDateRange?.[1] ? dayjs(values.reportDateRange[1]).format('MM/DD/YYYY') : '');
      break;
    case 'DriverManifest':
      params.append('drvId', values.assignedDriver?.driver?.id ?? '');
      break;
    case 'Invoice':
      params.append('custId', values.customer?.id ?? '');
      params.append('sortByName', '1');
      params.append('delvFromDate', values.deliveryDateRange?.[0] ? dayjs(values.deliveryDateRange[0]).format('MM/DD/YYYY') : '');
      params.append('delvToDate', values.deliveryDateRange?.[1] ? dayjs(values.deliveryDateRange[1]).format('MM/DD/YYYY') : '');
      break;
    case 'OpsProfitability':
      params.append('catId', values.jobCategories?.map((jobCategory) => jobCategory.id).join(',') ?? '');
      params.append('custId', values.customers?.map((customer) => customer.id).join(',') ?? '');
      params.append('dateFilter', values.dateType === 'Invoice Date' ? '2' : values.dateType === 'Pickup Date' ? '3' : '1');
      params.append('inclCharges', 'true');
      params.append('inclFsc', values.inclFsc ? 'true' : 'false');
      params.append('totalsOnly', values.totalsOnly ? 'true' : 'false');
      params.append('reportType', values.reportType === 'Summary' ? '5' : '1');
      params.append('apprvdClgs', values.driverPay === 'Approved' ? '1' : '2');
      params.append('svcId', values.services?.map((service) => service.id).join(',') ?? '');
      params.append('csxCode', values.consignees?.map((consignee) => consignee.id).join(',') ?? '');
    // Add cases for other report names here
  }
  return params;
}
